const getDisplayImageUrl = (path, fallbackName = 'Image', isFile = false) => {
  if (path && typeof path === 'string' && path.startsWith('http')) {
    return path;
  }
  if (path && typeof path === 'string') {
    return `${process.env.REACT_APP_API_BASE_URL}${path}`;
  }
  if (isFile) {
    return null; // For files, if no path, no current image to display
  }
  // Fallback for images if no path is provided
  const encodedName = encodeURIComponent(fallbackName);
  return `https://ui-avatars.com/api/?background=e11d48&color=fff&name=${encodedName}&size=512&bold=true`;
};

export { getDisplayImageUrl };